var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.852,
    height: 22.621,
    viewBox: "0 0 27.852 22.621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "twitter",
    d: "M24.989-13.109c.018.247.018.495.018.742,0,7.546-5.743,16.241-16.241,16.241A16.131,16.131,0,0,1,0,1.312a11.809,11.809,0,0,0,1.378.071A11.432,11.432,0,0,0,8.465-1.056,5.718,5.718,0,0,1,3.128-5.015a7.2,7.2,0,0,0,1.078.088,6.037,6.037,0,0,0,1.5-.194,5.709,5.709,0,0,1-4.577-5.6v-.071a5.749,5.749,0,0,0,2.58.725,5.7,5.7,0,0,1-2.545-4.754A5.665,5.665,0,0,1,1.944-17.7a16.225,16.225,0,0,0,11.77,5.973,6.444,6.444,0,0,1-.141-1.308,5.706,5.706,0,0,1,5.708-5.708,5.694,5.694,0,0,1,4.171,1.8,11.238,11.238,0,0,0,3.623-1.378,5.693,5.693,0,0,1-2.509,3.146,11.443,11.443,0,0,0,3.287-.884,12.27,12.27,0,0,1-2.863,2.951Z",
    transform: "translate(0 18.746)",
    fill: "#2e2e2e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.424eabb27beca35e3fa6bf9b001208b7.svg";
export { ForwardRef as ReactComponent };